/** The supported positions for the method */
export var Positions;
(function (Positions) {
    Positions["Top"] = "top";
    Positions["Bottom"] = "bottom";
    Positions["Left"] = "left";
    Positions["Right"] = "right";
})(Positions || (Positions = {}));
/**
 * This function gives us the positioning of the orbiter once
 * we've normalized things for detection.
 */
const getOrbiterBounds = (orbiter) => {
    const { style } = orbiter;
    // We want to get the bounds from an absolute position of
    // the first a relative parent
    style.top = '0px';
    style.left = '0px';
    style.bottom = 'auto';
    style.right = 'auto';
    // We need to get the bounds so we need the display to be block
    style.visibility = 'hidden';
    style.opacity = '1';
    style.display = 'block';
    style.transform = 'none';
    style.transition = 'none';
    const bounds = orbiter.getBoundingClientRect();
    // Assign the height and width with padding
    bounds.height = orbiter.clientHeight;
    bounds.width = orbiter.clientWidth;
    // Remove the temp styles from the oribiter we added for calc
    style.removeProperty('top');
    style.removeProperty('left');
    style.removeProperty('bottom');
    style.removeProperty('right');
    style.removeProperty('visibility');
    style.removeProperty('opacity');
    style.removeProperty('display');
    style.removeProperty('transform');
    style.removeProperty('transition');
    return bounds;
};
/**
 * This function ingests a set of elements, 1 target and 1 orbiter for now, and
 * handles positioning the orbiter around the target.
 */
export const positionElements = ({ target, orbiter, position }) => {
    const { style } = orbiter;
    const { height: targetHeight, width: targetWidth, top: targetTop, left: targetLeft, } = target.getBoundingClientRect();
    const { height: orbiterHeight, width: orbiterWidth, top: orbiterTop, left: orbiterLeft, } = getOrbiterBounds(orbiter);
    /**
     * Default explained
     *
     * Think of the target as a button and the orbiter as a menu
     *
     *            [ Target ]
     *             --------
     *     [       Orbiter ]
     *     [       Orbiter ]
     *     [       Orbiter ]
     */
    const orbiterStyles = window.getComputedStyle(orbiter);
    // Defaults to bottom if no position is provided or it's not top.
    if (position.includes(Positions.Top)) {
        const orbiterMarginBottom = parseInt(orbiterStyles.marginBottom.replace('px', ''), 10);
        let top;
        if (orbiterTop > 0) { // We are inside a relative parent
            top = targetTop - orbiterHeight - orbiterMarginBottom - orbiterTop;
        }
        else { // We are not inside a relative parent and need to account for window scroll
            top = targetTop - orbiterHeight + window.scrollY - orbiterMarginBottom;
        }
        style.top = `${top}px`;
    }
    else {
        const orbiterMarginTop = parseInt(orbiterStyles.marginTop.replace('px', ''), 10);
        style.top = `${(targetTop + targetHeight) - orbiterTop + orbiterMarginTop}px`;
    }
    style.bottom = 'auto';
    // Defaults to right if no position is provided or it's not left
    if (position.includes(Positions.Left)) {
        style.left = `${targetLeft - orbiterLeft}px`;
    }
    else {
        style.left = `${(targetLeft + targetWidth) - orbiterWidth}px`;
    }
    style.right = 'auto';
};
/**
 * Check if the provided element is positioned: relative, absolute, or fixed
 *
 * @param element Element to check position property of
 */
export const isPositioned = (element) => {
    const position = window.getComputedStyle(element).getPropertyValue('position');
    return ([
        'fixed',
        'absolute',
        'relative',
    ]).includes(position);
};
/**
 * Sets an element's position property to relative if it is not already positioned
 *
 * @param element Element to make positioned
 */
export const makePositioned = (element) => {
    if (!isPositioned(element)) {
        element.style.position = 'relative'; // eslint-disable-line no-param-reassign
    }
};
